module.exports = __webpack_public_path__ + "static/img/Complaint.fc5eaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Complaint.png
// module id = ec3L
// module chunks = 1